import React from 'react';
import PropTypes from 'prop-types';
import { EmptyTableMsg } from './EmptyTableMsg';

// This is basic flex table component. It allows you to render a flex table
// fairly easily. It is dependent on the corresponding flextable scss file.
// It has fixed number of columns/cells. It accepts a single prop, which
// is an array of rows of content. Within each row it has an array of columns.
// The array must be pre-poulated before passing it into the rows prop.
// Each column in the array can have either text or JSX. If a specific
// column or columns needs to have custom styling it should be done from
// Parent class and saved in the table array as JSX. If you plan to use
// different type of tables, you should make copy of this component and
// associated scss file and customize for that particular table.//
// Note: Default behavior of this compoment is to  display an empty table 
//       message if array is empty ( 0 length or length 1 if has header). 
//       You can override this behavior using the "displayWhenEmpty" prop. 
//       Options are: "message" or "none"
// The other default behavior is that component assumes table has a header
// and factors that in when deciding if table is empty. If table has no
// header then should set the "hasHeader" prop to false.
export class PicInvitationAttendeeStatusTable extends React.Component {

    constructor(props) {
        super(props);
    }
  
    // This method takes an array of rows. For each row it extracts a fixed number
    // of columns, constructs the jsx for that row, appends the jsx (for that row) 
    // via push to the jsx array. JSX is returned once all rows are processed.
    renderTable = (rows) => {
        let jxs = [];

        console.log("-----------------------------------")
        console.log("> PicListSAttendeeStatusTable PRE-render() method");
        console.log("  (v) rows ", rows);


        rows.forEach((row, i) => {
            let [col1, col2] = row;
            jxs.push(
               <div className="piat-flex-row" key={i}>
                    <div className="piat-flex-cell-1">
                        {col1}
                    </div>
                    <div className="piat-flex-cell-2">
                        {col2}
                    </div>
             </div>  
            )
        })
        return jxs;
    }

    render () {
        let { rows, displayWhenEmpty, hasHeader } = this.props;

        console.log("-----------------------------------")
        console.log("> PicListSAttendeeStatusTable render() method");
        console.log("  (v) rows ", rows);


        /* set defaults */
        hasHeader = true;
        displayWhenEmpty = this.props.displayWhenEmpty || "message";
        let emptySize = (hasHeader) ? 1 : 0;


        /* check if empty table along with display message */
        let isEmptyAndRequestMessage = (rows.length <= emptySize && displayWhenEmpty === "message") ? true : false;

        return (
        <div>
            { isEmptyAndRequestMessage && <EmptyTableMsg emptymsg="No individuals have been added to this event" modifierClass="empty-table-msg-mt" /> }

            {rows.length > emptySize &&
                 (
                  <div className="pict-flex-table-container"> 
                    <div className="pict-flex-table">
                        {this.renderTable(rows)}
                    </div>
                 </div>
                 ) 
            }
        </div>
        )
    }
}

PicInvitationAttendeeStatusTable.propTypes = {
    displayWhenEmpty:    PropTypes.string,
    hasHeader:           PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/components/PicInvitationAttendeeStatusTable.js